export default "__VITE_ASSET__DF1R5W2D__"